import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionProps, selectState } from '../../utils/reduxActions';
import { loginActions } from './reducer';

interface LoginProps {
  actions?: any;
  controls?: any;
  history?: any;
}

const PrivacyPolicy: React.FC<LoginProps> = props => {
  return (
    <>
      <div className='h-screen min-h-screen max-h-screen flex flex-col justify-center items-center p-4 w-full'>
        <h1 className='text-2xl font-bold mb-6'>
          Inabit - Aviso de Privacidad
        </h1>
        <iframe
          src='https://drive.google.com/file/d/1seAxorf7D-w9oSe7LwZvDBaoJTuKOUkZ/preview'
          className='w-3/4 h-full border-0'
          allow='autoplay'
          title='Inabit documento de aviso de privacidad'
        />
      </div>
    </>
  );
};

const withConnect = connect(
  selectState('login.controls'),
  actionProps({ ...loginActions }),
);

export default withRouter(withConnect(PrivacyPolicy));
